export default {
  name: 'dashify:simpleHighchart',
  title: 'Counter',
  owner: 'System',
  solution: '',
  tags: ['widget', 'counter'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    count: 0,
    derived: '/${ count * 10}',
    view: [
      ['p', { '.': 'p-2 mb-4' }, '/${ "count is " & count}'],
      ['p', { '.': 'p-2 mb-4' }, '/${ "derived state " & derived}'],
      [
        'div',
        { '.': 'h-[300px]' },
        [
          [
            'dashify:Highcharts',
            {
              plotOptions: {
                series: {
                  cursor: 'pointer',
                  events: {
                    click: '/${ function($e) { ($console.log($e);$set("/count", $e.point.y)) } }',
                  },
                },
              },
              height: 300,
              series: [
                {
                  data: [29.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
                },
              ],
            },
          ],
        ],
      ],
    ],
  },
};
